var _clipPath, _g, _mask, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 150",
    width: 200,
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_37"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,100,78.45600128173828)",
    opacity: 1
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-3.75,-9.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,200,12)",
    fillOpacity: 1,
    d: " M70.25,-81.75 C70.25,-81.75 70.25,81.75 70.25,81.75 C70.25,81.75 -70.25,81.75 -70.25,81.75 C-70.25,81.75 -70.25,-81.75 -70.25,-81.75 C-70.25,-81.75 70.25,-81.75 70.25,-81.75z"
  }))))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_37_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_37"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_37_1)",
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,100,77.55999755859375)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-1.75,-5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M58.75,37 C58.75,37 58.75,69.5 58.75,69.5 C58.75,73.91799926757812 55.167999267578125,77.5 50.75,77.5 C50.75,77.5 -50.75,77.5 -50.75,77.5 C-55.167999267578125,77.5 -58.75,73.91799926757812 -58.75,69.5 C-58.75,69.5 -58.75,36.75 -58.75,36.75"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-29.375,-42.375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 6.1,
    d: " M0,-3.2750000953674316 C1.807472586631775,-3.2750000953674316 3.2750000953674316,-1.807472586631775 3.2750000953674316,0 C3.2750000953674316,1.807472586631775 1.807472586631775,3.2750000953674316 0,3.2750000953674316 C-1.807472586631775,3.2750000953674316 -3.2750000953674316,1.807472586631775 -3.2750000953674316,0 C-3.2750000953674316,-1.807472586631775 -1.807472586631775,-3.2750000953674316 0,-3.2750000953674316z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,25.825000762939453,-42.375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 6.1,
    d: " M0,-3.2750000953674316 C1.807472586631775,-3.2750000953674316 3.2750000953674316,-1.807472586631775 3.2750000953674316,0 C3.2750000953674316,1.807472586631775 1.807472586631775,3.2750000953674316 0,3.2750000953674316 C-1.807472586631775,3.2750000953674316 -3.2750000953674316,1.807472586631775 -3.2750000953674316,0 C-3.2750000953674316,-1.807472586631775 -1.807472586631775,-3.2750000953674316 0,-3.2750000953674316z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,0.935479998588562,-1.5,2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-16.452999114990234,-10.470000267028809 C-12.991000175476074,-15.89900016784668 -6.915999889373779,-19.5 0,-19.5 C6.519000053405762,-19.5 12.291000366210938,-15.812000274658203 15.831999778747559,-10.934000015258789"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,-1.75,-5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-58.75,26.75 C-58.75,26.75 -58.75,-69.5 -58.75,-69.5 C-58.75,-73.91799926757812 -55.167999267578125,-77.5 -50.75,-77.5 C-50.75,-77.5 39,-77.5 39,-77.5 C39,-77.5 38.75,-65 38.75,-65 C39.25,-60.625 40.5,-57 46.75,-57 C46.75,-57 58.75,-57.25 58.75,-57.25 C58.75,-57.25 58.75,27 58.75,27"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M37.25,-83.375 C37.25,-83.375 56.875,-63 56.875,-63 C56.875,-63 37.25,-83.375 37.25,-83.375z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,9.600000381469727)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-60.125,22.25 C-60.125,22.25 -49.8120002746582,17.437999725341797 -49.8120002746582,17.437999725341797 C-49.8120002746582,17.437999725341797 -39.75,23.125 -39.75,23.125 C-39.75,23.125 -30.25,17.312000274658203 -30.25,17.312000274658203 C-30.25,17.312000274658203 -21,22.875 -21,22.875 C-21,22.875 -11.062000274658203,17.75 -11.062000274658203,17.75 C-11.062000274658203,17.75 -1.125,23 -1.125,23 C-1.125,23 8,17.5 8,17.5 C8,17.5 17.75,22.875 17.75,22.875 C17.75,22.875 27.25,17.625 27.25,17.625 C27.25,17.625 37.3120002746582,22.937999725341797 37.3120002746582,22.937999725341797 C37.3120002746582,22.937999725341797 46.25,17.437999725341797 46.25,17.437999725341797 C46.25,17.437999725341797 57,21.75 57,21.75"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-60.625,21.875 C-60.625,21.875 -49.8120002746582,17.437999725341797 -49.8120002746582,17.437999725341797 C-49.8120002746582,17.437999725341797 -39.75,23.125 -39.75,23.125 C-39.75,23.125 -30.25,17.312000274658203 -30.25,17.312000274658203 C-30.25,17.312000274658203 -21,22.875 -21,22.875 C-21,22.875 -11.062000274658203,17.75 -11.062000274658203,17.75 C-11.062000274658203,17.75 -1.125,23 -1.125,23 C-1.125,23 8,17.5 8,17.5 C8,17.5 17.75,22.875 17.75,22.875 C17.75,22.875 27.25,17.625 27.25,17.625 C27.25,17.625 37.3120002746582,22.937999725341797 37.3120002746582,22.937999725341797 C37.3120002746582,22.937999725341797 46.25,17.437999725341797 46.25,17.437999725341797 C46.25,17.437999725341797 57,21.75 57,21.75"
  })))))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5501607656478882,0,0,0.5600000023841858,98.9718017578125,76.66400146484375)",
    opacity: 1
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-104.5,73 C-104.5,73 52,73 52,73"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,68.24800109863281,76.66400146484375)",
    opacity: 1
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-104.5,73 C-104.5,73 -56.25,73 -56.25,73"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,196.09600830078125,76.66400146484375)",
    opacity: 1
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-104.5,73 C-104.5,73 -95.25,73 -95.25,73"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,206.6800079345703,76.66400146484375)",
    opacity: 1
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-104.5,73 C-104.5,73 -28.75,73 -28.75,73"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,201.13600158691406,71.4000015258789)",
    opacity: 1
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-104.5,73 C-104.5,73 -46.875,73 -46.875,73"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,89.58399963378906,71.4000015258789)",
    opacity: 1
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-104.5,73 C-104.5,73 -56.625,73 -56.625,73"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,100,77)",
    opacity: 1
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-98.375,-90.125 C-98.375,-90.125 -75.375,-81.125 -75.375,-81.125"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,100,77)",
    opacity: 1
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-85.25,-106 C-85.25,-106 -68.375,-88.875 -68.375,-88.875"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5600000023841858,0,0,0.5600000023841858,100,77)",
    opacity: 1
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-69.25,-118.75 C-69.25,-118.75 -61,-96.25 -61,-96.25"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.5599952936172485,-0.0000037601907934003975,0.0000037601907934003975,0.5599952936172485,99.99937438964844,76.99967193603516)",
    opacity: 1
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-121.06199645996094,17.937999725341797 C-121.06199645996094,17.937999725341797 -110.5,28.375 -110.5,28.375"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M-120.68800354003906,28.187999725341797 C-120.68800354003906,28.187999725341797 -110.125,17.625 -110.125,17.625"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.553704023361206,0.0837370976805687,-0.0837370976805687,0.553704023361206,102.78260803222656,49.910274505615234)",
    opacity: 1
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,84.625,2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M0,-15.625 C8.623437881469727,-15.625 15.625,-8.623437881469727 15.625,0 C15.625,8.623437881469727 8.623437881469727,15.625 0,15.625 C-8.623437881469727,15.625 -15.625,8.623437881469727 -15.625,0 C-15.625,-8.623437881469727 -8.623437881469727,-15.625 0,-15.625z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,84.625,2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M0,-12.225000381469727 C6.746977806091309,-12.225000381469727 12.225000381469727,-6.746977806091309 12.225000381469727,0 C12.225000381469727,6.746977806091309 6.746977806091309,12.225000381469727 0,12.225000381469727 C-6.746977806091309,12.225000381469727 -12.225000381469727,6.746977806091309 -12.225000381469727,0 C-12.225000381469727,-6.746977806091309 -6.746977806091309,-12.225000381469727 0,-12.225000381469727z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9995402097702026,0.030321186408400536,-0.030321186408400536,0.9995402097702026,0.118499755859375,-2.564723491668701)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,84.625,2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M-6.988999843597412,-5.863999843597412 C-5.315000057220459,-7.85699987411499 -2.803999900817871,-9.125 0,-9.125 C0,-9.125 0,-9.125 0,-9.125 C0.21400000154972076,-9.125 0.4259999990463257,-9.118000030517578 0.6359999775886536,-9.102999687194824"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,84.625,2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M3.565999984741211,-8.401000022888184 C4.8460001945495605,-7.855999946594238 5.97599983215332,-7.0279998779296875 6.877999782562256,-5.99399995803833"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,84.625,2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M6.451000213623047,6.451000213623047 C4.798999786376953,8.102999687194824 2.5179998874664307,9.125 0,9.125 C-0.8429999947547913,9.125 -1.659999966621399,9.010000228881836 -2.436000108718872,8.795999526977539"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,84.625,2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M-5.245999813079834,7.465000152587891 C-6.558000087738037,6.540999889373779 -7.616000175476074,5.2789998054504395 -8.293999671936035,3.806999921798706"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.7313537001609802,-0.6819983720779419,0.6763173341751099,0.7252615094184875,103.40599822998047,21.3439998626709)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M3.0940001010894775,-5.75 C3.0940001010894775,-5.75 3.0940001010894775,5.75 3.0940001010894775,5.75 C3.0940001010894775,7.457578182220459 1.7075786590576172,8.843999862670898 0,8.843999862670898 C0,8.843999862670898 0,8.843999862670898 0,8.843999862670898 C-1.7075786590576172,8.843999862670898 -3.0940001010894775,7.457578182220459 -3.0940001010894775,5.75 C-3.0940001010894775,5.75 -3.0940001010894775,-5.75 -3.0940001010894775,-5.75 C-3.0940001010894775,-7.457578182220459 -1.7075786590576172,-8.843999862670898 0,-8.843999862670898 C0,-8.843999862670898 0,-8.843999862670898 0,-8.843999862670898 C1.7075786590576172,-8.843999862670898 3.0940001010894775,-7.457578182220459 3.0940001010894775,-5.75z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(204,204,204)",
    strokeOpacity: 1,
    strokeWidth: 1,
    d: " M96.125,12.312000274658203 C96.125,12.312000274658203 94.40599822998047,14.25 94.40599822998047,14.25 C94.40599822998047,14.25 96.46900177001953,16.375 96.46900177001953,16.375 C96.46900177001953,16.375 98.31199645996094,14.656000137329102 98.31199645996094,14.656000137329102 C98.31199645996094,14.656000137329102 96.125,12.312000274658203 96.125,12.312000274658203z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.a123aacb047a7917bf43ebb39f92f9d3.svg";
export { ForwardRef as ReactComponent };